import * as React from 'react';

import { JRCFileViewerOpenWithOptionsType } from './types';
import { jFileLittle, resolveFileFamily, resolveFileMimetype, resolveFilePath } from 'jamespot-user-api';
import { JRCFileViewerContentApplication } from './JRCFileViewerContentApplication';
import { JRCFileViewerContentImage } from './JRCFileViewerContentImage';
import { JRCFileViewerContentAudio } from './JRCFileViewerContentAudio';
import { JRCFileViewerContentVideo } from './JRCFileViewerContentVideo';

import { JRCFileApplication } from 'components/JRCFile/JRCFileApplication';
import { JRCFileVideo } from 'components/JRCFile/JRCFileVideo';
import { JRCFileAudio } from 'components/JRCFile/JRCFileAudio';
import { JRCFileImage } from 'components/JRCFile/JRCFileImage';

type JRCFileViewerContentProps = {
    file: jFileLittle;
    size?: string;
    openWithOptions: JRCFileViewerOpenWithOptionsType;
};

export const JRCFileViewerContent = ({ file, size = 'fitx1200', openWithOptions }: JRCFileViewerContentProps) => {
    const fileFamily = resolveFileFamily(file);
    const mimetype = resolveFileMimetype(file);
    const uri = file.path ?? resolveFilePath(file, size);
    const options = openWithOptions.find((f) => f.condition(file))?.options;
    switch (fileFamily) {
        default:
            return (
                <JRCFileViewerContentApplication file={file} options={options}>
                    <JRCFileApplication mimetype={mimetype} />
                </JRCFileViewerContentApplication>
            );
        case 'application':
            return (
                <JRCFileViewerContentApplication file={file} options={options}>
                    <JRCFileApplication mimetype={mimetype} />
                </JRCFileViewerContentApplication>
            );
        case 'audio':
            return uri !== undefined ? (
                <JRCFileViewerContentAudio>
                    <JRCFileAudio uri={uri} mimetype={mimetype} />
                </JRCFileViewerContentAudio>
            ) : (
                <JRCFileViewerContentApplication file={file} options={options}>
                    <JRCFileAudio mimetype={mimetype} />
                </JRCFileViewerContentApplication>
            );
        case 'video':
            return uri !== undefined ? (
                <JRCFileViewerContentVideo>
                    <JRCFileVideo uri={uri} mimetype={mimetype} />
                </JRCFileViewerContentVideo>
            ) : (
                <JRCFileViewerContentApplication file={file} options={options}>
                    <JRCFileVideo mimetype={mimetype} />
                </JRCFileViewerContentApplication>
            );
        case 'gif':
        case 'image':
            return uri !== undefined ? (
                <JRCFileViewerContentImage>
                    <JRCFileImage uri={uri} mimetype={mimetype} size={1900} />
                </JRCFileViewerContentImage>
            ) : (
                <JRCFileViewerContentApplication file={file} options={options}>
                    <JRCFileApplication mimetype={mimetype} />
                </JRCFileViewerContentApplication>
            );
    }
};
